import script from "./YearEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./YearEditor.vue?vue&type=script&setup=true&lang=ts"

import "./YearEditor.vue?vue&type=style&index=0&id=56bdd87a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56bdd87a"]])

export default __exports__